import { createSlice } from "@reduxjs/toolkit";
import {
    fetchWhatsAppCredits,
    createWhatsAppCreditOrder,
    verifyAndAddCredits,
    fetchWhatsAppUsage,
} from "./thunks";

const initialState = {
    balance: 0,
    usage: [],
    loading: false,
    orderLoading: false,
    error: null,
    lastOrder: null,      // { order_id, amount, currency, key, credits_to_add }
    lastVerifyResult: null,
};

const whatsAppSlice = createSlice({
    name: "WhatsApp",
    initialState,
    reducers: {
        resetOrder(state) {
            state.lastOrder = null;
            state.lastVerifyResult = null;
            state.error = null;
        },
        clearError(state) {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // fetchWhatsAppCredits
        builder
            .addCase(fetchWhatsAppCredits.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchWhatsAppCredits.fulfilled, (state, action) => {
                state.loading = false;
                state.balance = action.payload.credits ?? 0;
            })
            .addCase(fetchWhatsAppCredits.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch credits";
            });

        // createWhatsAppCreditOrder
        builder
            .addCase(createWhatsAppCreditOrder.pending, (state) => {
                state.orderLoading = true;
                state.error = null;
                state.lastOrder = null;
            })
            .addCase(createWhatsAppCreditOrder.fulfilled, (state, action) => {
                state.orderLoading = false;
                state.lastOrder = action.payload;
            })
            .addCase(createWhatsAppCreditOrder.rejected, (state, action) => {
                state.orderLoading = false;
                state.error = action.payload || "Failed to create order";
            });

        // verifyAndAddCredits
        builder
            .addCase(verifyAndAddCredits.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(verifyAndAddCredits.fulfilled, (state, action) => {
                state.loading = false;
                state.lastVerifyResult = action.payload;
                if (action.payload.newBalance !== undefined) {
                    state.balance = action.payload.newBalance;
                }
                state.lastOrder = null;
            })
            .addCase(verifyAndAddCredits.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Payment verification failed";
            });

        // fetchWhatsAppUsage
        builder
            .addCase(fetchWhatsAppUsage.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchWhatsAppUsage.fulfilled, (state, action) => {
                state.loading = false;
                state.usage = action.payload.logs || [];
            })
            .addCase(fetchWhatsAppUsage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch usage";
            });
    },
});

export const { resetOrder, clearError } = whatsAppSlice.actions;
export default whatsAppSlice.reducer;
